import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../config";
import { checkLoggedInUserAuthorizedToViewPage, getDecodeURI } from "../../utils/util";
import { SIDE_MENU_ITEM_DASHBOARD } from "../../utils/constants";
import { BC_DASHBOARD_VESSELS, BC_DASHBOARD_ALERTS, BC_DASHBOARD_LOCATIONS } from "../../constants/Constants";
import { vesselLinkStatusSummaryDashboard, vesselSummaryDashboard,getTopWidgetAvailability} from '../../actions/Users/authenticateDashboard';
import { GET_WIDGEY_SUMMARY_DASHBOARD, GET_WIDGET_LINK_STATUS_SUMMARY_DASHBOARD, GET_TOP_WIDGET_AVAILABILITY } from "../../actions/types";
import { INTERVALS } from "../../constants/Constants";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import FleetSelection from "../../components/FleetSelection";
import NotAuthorized from "../NotAuthorized"
import CardDetail from "../../components/CardDetails";
import { updatePermission } from "../../actions/Users/authenticate";
import { displayToastError } from "../../server/request";
import "./FleetDashboard.css";
import _ from "lodash";
import { clearSiteDashboard } from "../../actions/Users/authenticateDashboard";
import SubHeaderSummary from "../../components/SubHeaderSummary";
import CommonFilters from "../../components/BreadCrumbs/CommonFilters";
import AnalyticsCardContents from "../../UserScreen/AnalyticsDashboard/AnalyticsCard";


var Loader = require("react-loader");
// const FILTER_BY_LIST = [
//   { label: "Vessel Name", value: "vesselName" },
//   { label: "System Type", value: "systemType" },
// ];

const FleetSummary = (props) => {
  const { authReducer, errorReducer, match, location, updatePermission, clearSiteDashboard, newSummaryStartDate, newSummaryEndDate, vesselLinkStatusSummaryDashboard, vesselSummaryDashboard, getTopWidgetAvailability } = props;
  let _q = getDecodeURI(location?.search);
  const setBreadcrumbInfo: any = React.useRef();
  const [search, setSearch] = useState<string>("");
  // const [filterBy, setFilterBy] = useState<string>("");
  const [interval, setInterval] = useState(_q.hasOwnProperty('interval') ? {label: _q.interval == '15mins' ? '15m' : _q.interval, value: _q.interval} : INTERVALS[1]);
  const [loading, setLoading] = useState(false);

  const [isAuthorizedToViewPage, setIsAuthorizedToViewPage] = useState<Boolean>(false);
  const VIEW_VESSEL_SUMMARY = "view-vessel-summary";
  const not_authorized_page_title = "Dashboard";
  const not_authorized_page_message = "You are not authorised to view site dashboard.";
  const [vessels, setVessels] = useState<JSON[]>([]);

  const [cardetails, setCardDetails] = useState({})
  const [cardetailsLinkStatus, setCardDetailsLinkStatus] = useState({})
  const [topWidgetAvailability, setTopWidgetAvailability] = useState({})
  const dispatch = useDispatch()
  // const location = useLocation();
  const [selectedVesselsList, setSelectedVesselsList] = useState([]);
  const [cardsData, setCardsData] = useState<any[]>([]);
  const [selectedCards, setSelectedCards] = useState<any[]>([
          {0:{heading: "Sites", rightValue: 0, showProgressBar: false}},
          {1:{heading: "Internet Links", rightValue: 0, showProgressBar: false}},
          {2:{heading: "Cellular", rightValue: 0, showProgressBar: false}},
          {3:{heading: "Starlink", rightValue: 0, showProgressBar: false}},
          {4:{heading: "VSAT", rightValue: 0, showProgressBar: false}},
          {5:{heading: "Wifi", rightValue: 0, showProgressBar: false}},
        ]);
  
    useEffect(() => {
      let tableData = authReducer?.widgetDashboardSummary?.data?.rows.map((item) => {
        return authReducer?.widgetDashboardSummary?.data?.columns.reduce((vsd, columnitem, i) => {
          vsd[columnitem] = item[i]
          return vsd;
        }, {})
      })
      if (tableData && tableData.length > 0) {
        setCardDetails(tableData[0])
      } else {
        setCardDetails({})
      }
    }, [authReducer.widgetDashboardSummary])
  
    useEffect(() => {
      let tableData = authReducer?.widgetLinkStatusDashboardSummary?.data?.rows.map((item) => {
        return authReducer?.widgetLinkStatusDashboardSummary?.data?.columns.reduce((vsd, columnitem, i) => {
          vsd[columnitem] = item[i]
          return vsd;
        }, {})
      })
      if (tableData && tableData.length > 0) {
        setCardDetailsLinkStatus(tableData[0])
        setCardsData([{0:{heading: "Sites", rightValue: tableData[0].online ? tableData[0].online: 0, showProgressBar: false}},
          {1:{heading: "Internet Links", rightValue: tableData[0].A_Link ? tableData[0].A_Link : 0, showProgressBar: false}},
          {2:{heading: "Cellular", rightValue: tableData[0].A_LTE_links ? tableData[0].A_LTE_links : 0, showProgressBar: false}},
          {3:{heading: "Starlink", rightValue: tableData[0].A_STAR_links ? tableData[0].A_STAR_links: 0, showProgressBar: false}},
          {4:{heading: "VSAT", rightValue: tableData[0].A_VSAT_links ? tableData[0].A_VSAT_links : 0, showProgressBar: false}},
          {5:{heading: "Wifi", rightValue: tableData[0].A_WIFI_links ? tableData[0].A_WIFI_links : 0, showProgressBar: false}},
          {6:{heading: "Ethernet", rightValue: tableData[0].A_WIRED_links ? tableData[0].A_WIRED_links : 0, showProgressBar: false}},
          {7:{heading: "LBand", rightValue: tableData[0].A_FBB_links ? tableData[0].A_FBB_links : 0, showProgressBar: false}},
          {8:{heading: "Oneweb", rightValue: tableData[0].A_ONEWEB_links ? tableData[0].A_ONEWEB_links : 0, showProgressBar: false}},
          {9:{heading: "Starlink_R", rightValue: tableData[0].A_STARLINK_R_links ? tableData[0].A_STARLINK_R_links : 0, showProgressBar: false}},
        ])
        setSelectedCards([
          {0:{heading: "Sites", rightValue: tableData[0].online ? tableData[0].online: 0, showProgressBar: false}},
          {1:{heading: "Internet Links", rightValue: tableData[0].A_Link ? tableData[0].A_Link : 0, showProgressBar: false}},
          {2:{heading: "Cellular", rightValue: tableData[0].A_LTE_links ? tableData[0].A_LTE_links : 0, showProgressBar: false}},
          {3:{heading: "Starlink", rightValue: tableData[0].A_STAR_links ? tableData[0].A_STAR_links: 0, showProgressBar: false}},
          {4:{heading: "VSAT", rightValue: tableData[0].A_VSAT_links ? tableData[0].A_VSAT_links : 0, showProgressBar: false}},
        ]);
      } else {
        setCardDetailsLinkStatus({});
        setCardsData([]);
      }
    }, [authReducer.widgetLinkStatusDashboardSummary])
  
    useEffect(() => {
      let tableData = authReducer?.setTopWidgetAvailability?.data?.rows.map((item) => {
        return authReducer?.setTopWidgetAvailability?.data?.columns.reduce((vsd, columnitem, i) => {
          vsd[columnitem] = item[i]
          return vsd;
        }, {})
      })
      if (tableData && tableData.length > 0) {
        setTopWidgetAvailability(tableData[0])
      } else {
        setTopWidgetAvailability({})
      }
    },[authReducer?.setTopWidgetAvailability])
  
    useEffect(() => {
      // create new requestAborter
      let _requestAbortController = new AbortController();
      let _q = getDecodeURI(location.search)
      let _interval = _q.interval == '15mins' ? _q.interval.replace('15mins', '15m') : _q.interval;
      if (interval && Object.keys(interval).length > 0 && !_.isEmpty(vessels)) {
        // let vessels = [];
        let params = getDecodeURI(location?.search);
        let filter= "";
        if(!_.isEmpty(params) && params.hasOwnProperty("filterApplied")){
          let statues = params?.internetStatus;
          if(statues){
            statues = statues.split(",")
            statues="'" + statues.join("','") + "'";
            filter = "AND status IN(" + statues+")"
          }
        }
        if(vessels?.length > 0) {
          // getTopWidgetAvailability(selectedVesselsList,search,interval.value,filter, newSummaryStartDate, newSummaryEndDate);
          vesselSummaryDashboard(vessels as [JSON], search, _interval, authReducer.selectedOu?.name, _requestAbortController.signal, filter, newSummaryStartDate, newSummaryEndDate);
          vesselLinkStatusSummaryDashboard(vessels as [JSON], search, _interval, authReducer.selectedOu?.name, _requestAbortController.signal, filter);
        } else {
          dispatch({type: GET_WIDGEY_SUMMARY_DASHBOARD, payload: {}})
          dispatch({type: GET_WIDGET_LINK_STATUS_SUMMARY_DASHBOARD, payload: {}})
          dispatch({type: GET_TOP_WIDGET_AVAILABILITY, payload: {}})
          return;
        }
      }
  
      return () => {
        _requestAbortController.abort()
      }
    }, [vessels, search, newSummaryStartDate, newSummaryEndDate]);
  
    useEffect(() => {
      if (!_.isEmpty(errorReducer.errorGetVesselSummaryDashboard)) {
        displayToastError(errorReducer.errorGetVesselSummaryDashboard.description)
        errorReducer.errorGetVesselSummaryDashboard = {};
      }
    }, [errorReducer.errorGetVesselSummaryDashboard]);

  const viewVesselSummaryService = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["service"];
  const viewVesselSummaryFunction = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["function"];
  let breadcrumbInfo = BC_DASHBOARD_VESSELS;

  if (authReducer && (!authReducer.sideMenu || SIDE_MENU_ITEM_DASHBOARD !== authReducer.sideMenu.menuItem)) {
    authReducer.sideMenu = { menuItem: SIDE_MENU_ITEM_DASHBOARD };
  }

  useEffect(() => {
    let authorized = checkLoggedInUserAuthorizedToViewPage(viewVesselSummaryService, viewVesselSummaryFunction);
    setIsAuthorizedToViewPage(authorized);
    const info = {
      permission: {
        service: viewVesselSummaryService,
        serviceFunction: viewVesselSummaryFunction,
      },
      isMultiVessel: false,
      isSingleVessel: false,
      showOu: false,
      ou: authReducer?.selectedOu ? authReducer.selectedOu : ''
    };

    if (authorized) {
      info.isMultiVessel = true;
      info.showOu = true;
    }

    updatePermission(info);

    return () => {
      clearSiteDashboard();
    }
  }, []);

  useEffect(() => {
    setLoading(authReducer.vesselDashboardLoading ||
      authReducer.vesselSummaryLoading || authReducer?.vesselTableCountLoading ||
      authReducer.searchAlertsLoading ||
      authReducer.vesselLocWithAlertsLoading || authReducer.loading || authReducer.edgeServerStatusLoading || authReducer?.vesselWanLinkStatusLoading || authReducer?.sportSiteSummaryCountLoading ||
      authReducer.setWanProfilePerDeviceLoading || authReducer.setAdvancedBondingLoading || authReducer.setLANStatusLoading || authReducer.setConnectedHubLoading
    );
  }, [authReducer.vesselDashboardLoading,
  authReducer.vesselSummaryLoading, authReducer?.vesselTableCountLoading,
  authReducer.searchAlertsLoading,
  authReducer.vesselLocWithAlertsLoading, authReducer.loading, authReducer.edgeServerStatusLoading,authReducer?.vesselWanLinkStatusLoading, authReducer?.sportSiteSummaryCountLoading,
  authReducer.setWanProfilePerDeviceLoading , authReducer.setAdvancedBondingLoading, authReducer.setLANStatusLoading, authReducer.setConnectedHubLoading
]);

  const handleSelctedSubDetails = () => {}

  useEffect(() => {
    if (_.isEmpty(authReducer?.getVesselsListing))
        return;
    let vessels = [];
    const filteredVessels = authReducer?.filteredVessels;
    if (filteredVessels && filteredVessels.length > 0) {
        vessels = filteredVessels;
    } else if(!_q.hasOwnProperty('k4Ids')) {
        vessels = authReducer?.getVesselsListing?.locations;
    }
    setVessels(vessels);
}, [authReducer?.getVesselsListing, authReducer?.filteredVessels]);

  return (
    <div className="Form">
      <div>
        {/* <SubHeaderSummary newSummary={true} subHeaderSelectedDropdown={handleSelctedSubDetails} setTimePeriod={setInterval} showWantType={false} /> */}
        <CommonFilters loading={loading || authReducer?.userPreferencesLoading} showWantType={false} periodOptions={['1h','15mins','2h','6h','12h','1d', '7d', '30d']} isCustomPeriodSelectionRequired={false} userGuide={[true, 'sites']} />      
      
      </div>
      <Grid key="dashboard" item container style={{ backgroundColor: "#ffffff" }}>
        <Grid key="fleet" item className="site-dashboard--container">
          {
            isAuthorizedToViewPage ? [
              <Grid key="SubHeader" item container className="SubHeader" style={{borderBottom: "none"}}>
                {/* <CardDetail search={search} interval={interval} vesselList={vessels} selectedOu={authReducer.selectedOu} /> */}
                {/* <TopCards cardsData={cardsData}/> */}
                <AnalyticsCardContents cardsData={selectedCards}/>
              </Grid>,

              <Grid key="summary" className="summary sitesTableMargin">
                <FleetSelection  search={search} setSearch={setSearch} interval={interval} setInterval={setInterval}  loader={loading} isMapEnabled={true} vesselList={vessels} cardsData={cardsData} selectedCards={selectedCards} setSelectedCards={setSelectedCards}/>
              </Grid>
            ] :
              <Grid key="noitems" item container style={{ position: "fixed", paddingBottom: "16px", backgroundColor: "#ffffff", zIndex: 10, paddingTop: "80px" }}>
                <NotAuthorized pageTitle={not_authorized_page_title} PageMessage={not_authorized_page_message} />
              </Grid>
          }
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  errorReducer: state.errorReducer,
  vesselDashboardSummary: state?.authReducer?.vesselDashboardSummary,
  setTopWidgetAvailability: state?.authReducer?.setTopWidgetAvailability,
  newSummaryStartDate: state.authReducer.newSummaryStartDate,
  newSummaryEndDate: state.authReducer.newSummaryEndDate,
});

export default withRouter(
  connect(mapStateToProps, { updatePermission, 
    clearSiteDashboard, 
    vesselSummaryDashboard,
    vesselLinkStatusSummaryDashboard,
    getTopWidgetAvailability })(FleetSummary)
);
